<template>
  <div>
    <Head title="Get a Run in Project" />
    <h1 class="mb-4 text-4xl font-bold text-center text-blue-600">
      Get a Custom Run in Project
    </h1>
    <p class="text-gray-400 text-center max-w-xl m-auto mb-8">
      Please fill the form below to receive a quote for you project, Feel free to add much details as needed.
    </p>

    <div class="flex items-center justify-center max-w-4xl text-center m-auto mt-20 mb-10">
      <div class="rounded-full px-4 py-3" :class="form.step >= 1 ? 'bg-blue-800 text-white': 'bg-gray-200 text-gray-600'">1</div>
      <div class="rounded w-20 h-2 mx-3" :class="form.step >= 2 ? 'bg-blue-800': 'bg-gray-200'">&nbsp;</div>
      <div class="rounded-full px-4 py-3" :class="form.step >= 2 ? 'bg-blue-800 text-white': 'bg-gray-200 text-gray-600'">2</div>
    </div>

    <div class="rounded w-full max-w-xl text-center m-auto h-px bg-gray-200 mb-10">&nbsp;</div>
    <form @submit.prevent="store">
      <StepOne
        v-if="form.step == 1"
        :value="stepModel"
        :project="project"
        @input="updateForm($event)"
      />

      <StepTwo
        v-if="form.step == 2"
        :value="stepModel"
        :props="stepTwoProps"
        :filter-by="filterBy"
        @input="updateForm($event)"
        @move="moveToSection($event)"
      />
    </form>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout.vue'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import pick from 'lodash/pick'
import StepOne from '../Partials/Create/StepOne.vue'
import StepTwo from '../Partials/Custom/StepTwo.vue'

let callGetFilters = {
  handler: throttle(function() { this.getFilters() }, 150),
  deep: true,
}

export default {
  components: {
    Head,
    StepOne,
    StepTwo,
  },
  layout: Layout,
  remember: 'form',
  props: {
    project    : Object,
    systems    : Object,
    widths     : Array,
    edges      : Array,
    canBeSloped: Boolean,
    loadClass  : Array,
    materials  : Array,
    types      : Array,
    compliances: Array,
    grates     : [Object, Array],
    filters    : Object,
  },
  data() {
    return {
      filterBy : {
        loadClass  : this.filters.loadClass  ? this.filters.loadClass.map((c) => parseInt(c))    : [],
        materials  : this.filters.materials  ? this.filters.materials.map((m) => parseInt(m))    : [],
        types      : this.filters.types  ? this.filters.types.map((t) => parseInt(t))            : [],
        compliances: this.filters.compliances  ? this.filters.compliances.map((c) => parseInt(c)): [],
      },
      form: this.$inertia.form({
        step : 1,
        name             : null,
        system           : this.filters.system ?? null,
        devices          : true,
        edge             : this.filters.edge ?? null,
        width            : this.filters.width ?? null,
        grate            : null,
        length           : 0,
      }),
    }
  },
  computed: {
    stepModel () {
      return this.form
    },
    stepTwoProps () {
      return {
        systems    : this.systems,
        widths     : this.widths,
        edges      : this.edges,
        loadClass  : this.loadClass,
        materials  : this.materials,
        types      : this.types,
        compliances: this.compliances,
        grates     : this.grates,
      }
    },
    run () {
      let { name, system, width, edge, length, grate, channel_depth, depth, outlet, outlet_type_id, outlet_size, } = this.form
      system = system ? this.systems.find((s) => s.id == system) : {}
      let outletType = outlet_type_id ? this.outletTypes.find((ot) => ot.id == outlet_type_id): {}

      return  {
        'name'             : name,
        'system'           : system.name,
        'width'            : width ? this.widths.find((e) => e.value == width).label : '',
        'edge'             : edge ? this.edges.find((e) => e.id == edge).name : '',
        'length'           : `${this.MetricToFeet(length)} feet / ${length} meters`,
        'channel_depth'    : channel_depth ? this.depths.find((e) => e.value = channel_depth).label: '',
        'depth'            : depth == 1  ? 'Sloped Run' : 'Constant Depth',
        'outlet'           : outlet ?  this.outlets.find((o) => o.id == outlet).name : '',
        'outlet_type'      : outletType.name,
        'outlet_size'      : outlet_size ? `${outlet_size} in / ${this.InchesToMelimeters(outlet_size)} mm` :  false,
        'grate'            : grate == null ? null : {
          'class'      : grate.class,
          'icon'       : this.loadClass.find((e) => e.id == grate.class_id).icon,
          'material'   : grate.material,
          'compliances': grate.compliances,
        },
        filters : [
          {
            img  : system.img,
            label: system.name,
          },
          {
            img        : grate.img,
            label      : grate.label,
            compliances: grate.compliances,
            parts      : grate.parts,
          },
          {
            img: outletType.img_src,
            label: outletType.name,
          },
        ],
      }
    },
  },
  watch: {
    'form.system' : {
      handler: throttle(function() {
        this.form.devices = (this.form.system == 2 || this.form.system == 3)
        this.getFilters()
      }, 150),
      deep: true,
    },
    'form.width'            : callGetFilters,
    'form.edge'             : callGetFilters,
    'filterBy.loadClass'    : callGetFilters,
    'filterBy.materials'    : callGetFilters,
    'filterBy.types'        : callGetFilters,
    'filterBy.compliances'  : callGetFilters,
  },
  mounted() {
    if (this.form.name) {
      this.step = 2
    }
  },
  methods: {
    store() {
      this.form
        .transform((data) => ({
          ...data,
          system_id  : data.system,
          edge_id    : data.edge,
          width_id   : data.width,
          class_id   : data.grate.class_id,
          material_id: data.grate.material_id,
          design_id  : data.grate.design_id,
        }))
        .post(`/projects/${this.project.id}/customs`, {
          preserveState: true,
          onError: (errors) => {
            if (errors.name) {
              this.form.step = 1
            }
          },
        })
    },
    getFilters () {
      let filterBy = pickBy(
        pick(this.filterBy, ['loadClass', 'materials', 'types', 'compliances']),
      )

      let form = pickBy(
        pick(this.form, ['system', 'width', 'edge']),
      )

      let params = {
        ...filterBy,
        ...form,
      }

      this.$inertia.get(
        `/projects/${this.project.id}/customs/create`,
        params, {
          preserveState: true,
          preserveScroll: true,
        })
    },
    updateForm ({key, value}) {
      if (! key.includes('form')) {
        if (value == 3 ) {
          this.store()
          return
        }

        this.form.step = value
        return
      }
      let arr = key.split('.')
      let k = arr[arr.length - 1]
      this.form[k] = value
    },
    moveToSection (section) {
      setTimeout(() => {
        let scrollRegion = document.getElementById('scroll-region')
        let el           = document.getElementById(section)
        if (el) {
          scrollRegion.scroll({
            top: el.offsetTop - 100,
            left: 0,
            behavior: 'smooth',
          })
        }
      }, 200)
    },
  },
}
</script>
